export function createUETSelectorClass(uetClass, scope) {
  return class AdvancedOptionsView extends uetClass {
    initialize() {
      super.initialize({
        enabled: true,
        showManageTagLink: false,
        usePanel: false,
        scope,
      });
    }
  };
}
